<template>
  <v-dialog
    v-model="show"
    max-width="600px"
  >
    <v-form
      ref="deleteForm"
      @submit.prevent="submit"
    >
      <v-card>
        <v-card-title
          class="text-body-1"
        >
          {{ $t('TaskList.PleaseConfirm') }}
        </v-card-title>
        <v-select
          v-model="actionType"
          :items="type"
          item-value="id"
          item-text="desc"
          :disabled="!hasUnapprove"
          outlined
          class="mx-5"
        />
        <v-text-field
          v-model="message"
          :label="$t('TrainingClient.Reason')"
          outlined
          class="mx-5"
          :rules="rules.required"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="show = false"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="submit"
          >
            {{ $t('ConfirmModal.OK') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import VuetifyJetValidator from 'vuetify-jet-validator'

const validator = new VuetifyJetValidator()

export default {
  props: {
    hasUnapprove: {
      type: Boolean,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      show: this.value,
      actionType: 1,
      message: this.$t('Text.Cancel'),
      rules: {
        required: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      }
    }
  },
  computed: {
    type: function () {
      return [{
        id: 1, // delete
        desc: this.$t('TaskList.CancelApplication')
      }, {
        id: 2, // unapprove
        desc: this.$t('TaskList.Unapprove.NeedSign')
      }]
    }
  },
  watch: {
    value: function (val) {
      this.show = val
    },
    show: function (val) {
      this.$emit('input', val)
    },
    actionType: function () {
      this.message = null
    }
  },
  methods: {
    submit: function () {
      if (!this.$refs.deleteForm.validate()) {
        return false
      }
      if (this.actionType === 1) {
        this.$emit('delete', this.message)
      } else if (this.actionType === 2) {
        this.$emit('unapprove', this.message)
      }
      this.show = false
    }
  }
}
</script>
